import { DonutTier, isStackedTier } from '../../tier';

export type DonutLayout = {
  outerScale: number;
  outerMin: number;
  outerMax: number;
  innerRatio: number;
  centerX: string;
  centerY: string;
  labelLength: number;
  labelLength2: number;
  labelFontSize: number;
  legendFontSize: number;
  legendItemSize: number;
};

export function layoutForTier(tier: DonutTier): DonutLayout {
  switch (tier) {
    case 'sm':
      return {
        outerScale: 0.32,
        outerMin: 50,
        outerMax: 100,
        innerRatio: 0.68,
        centerX: '50%',
        centerY: '50%',
        labelLength: 10,
        labelLength2: 10,
        labelFontSize: 11,
        legendFontSize: 11,
        legendItemSize: 11,
      };
    case 'lg':
      return {
        outerScale: 0.31,
        outerMin: 60,
        outerMax: 115,
        innerRatio: 0.70,
        centerX: '50%',
        centerY: '50%',
        labelLength: 6,
        labelLength2: 5,
        labelFontSize: 11,
        legendFontSize: 12,
        legendItemSize: 12,
      };
    case 'md':
      return {
        outerScale: 0.22,
        outerMin: 60,
        outerMax: 130,
        innerRatio: 0.68,
        centerX: '36%',
        centerY: '50%',
        labelLength: 10,
        labelLength2: 8,
        labelFontSize: 13,
        legendFontSize: 14,
        legendItemSize: 14,
      };
    case 'xl':
    default:
      return {
        outerScale: 0.2,
        outerMin: 60,
        outerMax: 130,
        innerRatio: 0.68,
        centerX: '37%',
        centerY: '50%',
        labelLength: 10,
        labelLength2: 8,
        labelFontSize: 13,
        legendFontSize: 12,
        legendItemSize: 12,
      };
  }
}

export function shouldRenderHtmlLegend(tier: DonutTier): boolean {
  return isStackedTier(tier);
}
